const d = (i) => ({ transitionDelay: `${(i * 0.07).toFixed(2)}s` });

const CARDS = [
  {
    category: "Home",
    img: "/images/emmy-home.jpg",
    h: "Home & Harmony",
    p: "Functional pieces, intentional habits, and simple systems that help our home run with less stress and more joy.",
  },
  {
    category: "Beauty",
    img: "/images/emmy-beauty.jpg",
    h: "Body & Spirit",
    p: "The wellness, skincare, and daily rituals that help me show up as my best self—for myself and my family.",
  },
  {
    category: "Style",
    img: "/images/emmy-style.jpg",
    h: "Traveling as a Family",
    p: "The gear, clothing, and travel essentials we rely on as we explore the world together.",
  },
];

export default function ShopPanel({ onShop }) {
  return (
    <section className="panel" id="shop" data-i="2" data-testid="panel-shop">
      <div className="shop-inner">
        <div className="eyebrow-v5 reveal" style={{ textAlign: "center", ...d(0) }}>
          Shop my picks
        </div>
        <h2 className="shop-h reveal" style={d(1)}>
          Tools, finds &amp; favorites for an intentional life.
        </h2>
        <p className="shop-sub reveal" style={d(2)}>
          Everything here I truly use and love.
        </p>
        <div className="shop-cards">
          {CARDS.map((c, i) => (
            <button
              className="shop-card reveal"
              style={d(3 + i)}
              key={c.category}
              data-testid={`shop-card-${c.category.toLowerCase()}`}
              onClick={() => onShop({ title: c.h, category: c.category })}
            >
              <div className="thumb">
                <img src={c.img} alt={c.h} />
              </div>
              <div className="body">
                <h3>{c.h}</h3>
                <p>{c.p}</p>
                <span className="go">Shop the edit →</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
